module.exports = __webpack_public_path__ + "img/bg_3.b9f93633.jpg";